import { LandingsDisabledBanner } from '@/pages/landings/landings-disabled-banner';
import { useLandingsAccess } from '@/hooks/use-landings-access';
import type { ReactNode } from 'react';
import { Spinner } from '@/components/ui/spinner';

interface LandingsGateProps {
	children: ReactNode;
}

export default function LandingsGate({ children }: LandingsGateProps) {
	const { enabled, accessible, loading } = useLandingsAccess();

	if (!enabled) {
		return <LandingsDisabledBanner reason='disabled' />;
	}

	if (loading) {
		return (
			<div className='flex justify-center py-16'>
				<Spinner />
			</div>
		);
	}

	if (!accessible) {
		return <LandingsDisabledBanner reason='token' />;
	}

	return <>{children}</>;
}
